import axios from "axios";

let apiClient;
let cachedConfig;

const loadConfig = async () => {
  if (cachedConfig) return cachedConfig;

  const response = await fetch(
    `${window.location.origin}/ResearchersAward/Helpers/main.json`
  );
  cachedConfig = await response.json();
  return cachedConfig;
};

export const initializeApiClient = async (ContentType) => {
  if (apiClient) return apiClient; // إذا جاهز
  const config = await loadConfig();

  apiClient = axios.create({
    baseURL: config.domainUrl,
    timeout: 900000,
    withCredentials: true,
  });

  // ✅ إضافة Interceptor للهيدر
  apiClient.interceptors.request.use(
    (cfg) => {
      // لو في Content-Type مطلوب
      if (ContentType && !(cfg.data instanceof FormData)) {
        cfg.headers["Content-Type"] = ContentType;
      }

      // ✅ جلب التوكن من localStorage أو sessionStorage
      const token = sessionStorage.getItem("AccessToken")||sessionStorage.getItem("AccessTokenManager"); 
      if (token) {
        cfg.headers["Authorization"] = `${token}`;
      }

      return cfg;
    },
    (error) => Promise.reject(error)
  );

  return apiClient;
};

export const getApiClient = () => {
  if (!apiClient) {
    throw new Error("API client is not initialized. Call initializeApiClient first.");
  }
  return apiClient;
};

export default loadConfig;
